// extracted by mini-css-extract-plugin
export default {"root__image":"style-module__root__image___M86s3","root__info":"style-module__root__info___qHBfA","root__info_title":"style-module__root__info_title___oKRIs","root__artists":"style-module__root__artists___DM6Yj"};
    if(module.hot) {
      // 1697460476169
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  